import React, { Component } from 'react'
import { inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import Notifications from '@components/Notifications'

class HeaderDropdown extends Component {
  static propTypes = {
    isNotification: PropTypes.bool,
    userStore: PropTypes.object,
    handleOutsideClick: PropTypes.func
  }

  handleLogout = () => {
    const { userStore } = this.props
    userStore.logout()
  }

  handleClickOutside = () => {
    this.props.handleOutsideClick()
  }

  render () {
    const { isNotification } = this.props
    return (
      <div
        className={`header__actions__dropdown
      ${isNotification ? '' : 'header__actions__dropdown--user'}`}
      >
        <div className='arrow-up' />
        <div className='notification-dropdown'>
          {isNotification ? (
            <Notifications
              isInPopup
              handleOutsideClick={this.handleClickOutside}
            />
          ) : (
            <div>
              <div className='user-dropdown'>
                <Link to='/profile'>
                  <div
                    className='user-dropdown__item'
                    onClick={this.handleClickOutside}
                  >
                    My profile
                  </div>
                </Link>
                <Link to='/settings'>
                  <div
                    className='user-dropdown__item'
                    onClick={this.handleClickOutside}
                  >
                    Settings
                  </div>
                </Link>
              </div>
              <div
                className='user-dropdown__item link'
                onClick={this.handleLogout}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default inject('userStore')(HeaderDropdown)
